<div class="clover-payment">
  @if (isLoading()) {
    <div class="clover-payment__loading">
      Loading secure payment fields...
    </div>
  }

  @if (error()) {
    <div class="clover-payment__error">
      {{ error() }}
    </div>
  }

  <div class="clover-payment__fields" [class.clover-payment__fields--hidden]="isLoading() || error()">
    <div class="clover-payment__field">
      <span class="clover-payment__field-label">Card Number</span>
      <div id="card-number" class="clover-payment__field-iframe"></div>
      @if (cardNumberError()) {
        <span class="clover-payment__field-error">{{ cardNumberError() }}</span>
      }
    </div>

    <div class="clover-payment__row">
      <div class="clover-payment__field">
        <span class="clover-payment__field-label">Expiration Date</span>
        <div id="card-date" class="clover-payment__field-iframe"></div>
        @if (cardDateError()) {
          <span class="clover-payment__field-error">{{ cardDateError() }}</span>
        }
      </div>

      <div class="clover-payment__field">
        <span class="clover-payment__field-label">CVV</span>
        <div id="card-cvv" class="clover-payment__field-iframe"></div>
        @if (cardCvvError()) {
          <span class="clover-payment__field-error">{{ cardCvvError() }}</span>
        }
      </div>

      <div class="clover-payment__field">
        <span class="clover-payment__field-label">Postal Code</span>
        <div id="card-postal-code" class="clover-payment__field-iframe"></div>
        @if (cardPostalCodeError()) {
          <span class="clover-payment__field-error">{{ cardPostalCodeError() }}</span>
        }
      </div>
    </div>
  </div>
</div>
